/* Maison Atlas : hero photo + trois reels. Le reel actif choisit la photo de fond, le titre (h1 unique) et le texte ; seule sa video joue ; compte a rebours. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const pad = (n) => String(n).padStart(2, '0');

  function initCountdown(el) {
    const end = Date.parse(el.dataset.end);
    if (Number.isNaN(end)) return;
    const parts = {
      d: el.querySelector('[data-d]'),
      h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'),
      s: el.querySelector('[data-s]'),
    };
    let timer = null;
    const tick = () => {
      let rest = end - Date.now();
      if (rest <= 0) {
        el.hidden = true;
        if (timer) window.clearInterval(timer);
        return;
      }
      const d = Math.floor(rest / 86400000);
      rest -= d * 86400000;
      const h = Math.floor(rest / 3600000);
      rest -= h * 3600000;
      const m = Math.floor(rest / 60000);
      rest -= m * 60000;
      const s = Math.floor(rest / 1000);
      if (parts.d) parts.d.textContent = pad(d);
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(s);
    };
    tick();
    timer = window.setInterval(tick, 1000);
  }

  function initHero(root) {
    if (root.dataset.maReady) return;
    root.dataset.maReady = 'true';

    const reels = Array.from(root.querySelectorAll('[data-ma-hero-reel]'));
    const texts = Array.from(root.querySelectorAll('[data-ma-hero-text]'));
    const bgs = Array.from(root.querySelectorAll('[data-ma-hero-bg]'));
    const h1 = root.querySelector('[data-ma-hero-h1]');
    const eyebrow = root.querySelector('[data-ma-hero-eyebrow]');
    let current = Math.max(0, reels.findIndex((r) => r.getAttribute('aria-pressed') === 'true'));

    const setActive = (index) => {
      if (index < 0 || index >= reels.length) return;
      current = index;
      reels.forEach((reel, i) => reel.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
      texts.forEach((text, i) => {
        text.hidden = i !== index;
      });
      bgs.forEach((bg, i) => {
        bg.classList.toggle('is-active', i === index);
        if (i === index) {
          const img = bg.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        }
      });
      const text = texts[index];
      if (text && h1) {
        h1.textContent = text.dataset.title || '';
        h1.style.animation = 'none';
        void h1.offsetWidth;
        h1.style.animation = '';
      }
      if (text && eyebrow) {
        eyebrow.textContent = text.dataset.eyebrow || '';
        eyebrow.hidden = !text.dataset.eyebrow;
      }
      syncVideos();
    };

    reels.forEach((reel, i) => reel.addEventListener('click', () => setActive(i)));

    const videos = Array.from(root.querySelectorAll('video'));
    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('tabindex', '-1');
      video.setAttribute('aria-hidden', 'true');
    });

    /* Seule la video du reel actif joue (et seulement quand le hero est visible) ; les autres restent sur leur affiche, sans prechargement. */
    let heroVisible = false;
    const canPlay = !reduceMotion && !saveData;
    function syncVideos() {
      videos.forEach((video) => {
        const reel = video.closest('[data-ma-hero-reel]');
        const active = reel ? reels.indexOf(reel) === current : false;
        if (canPlay && active && heroVisible) {
          video.preload = 'auto';
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => {});
        } else {
          video.pause();
          if (!active) video.preload = 'none';
        }
      });
    }

    if (canPlay && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => {
          heroVisible = entry.isIntersecting;
          syncVideos();
        },
        { threshold: 0.25 }
      ).observe(root);
    } else {
      syncVideos();
    }

    root.querySelectorAll('[data-ma-countdown]').forEach(initCountdown);
  }

  const boot = () => document.querySelectorAll('[data-ma-hero]').forEach(initHero);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-ma-hero]');
    if (root) initHero(root);
  });
})();